module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_tiempo_1973.09d41306.jpg";